import { useState } from "react";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { AppearanceModal } from "./components/AppearanceModal";
import { FALLBACK_AVATAR } from "./lib/avatars";
import { ChildDashboard } from "./pages/ChildDashboard";
import { LoginPage } from "./pages/LoginPage";
import { ParentDashboard } from "./pages/ParentDashboard";

export default function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}

/**
 * Routing is a single role check rather than a router library: the MVP has one
 * screen per role plus a login page, and the "route" is entirely determined by
 * who is signed in. Revisit if phase 2 adds deep links.
 */
function Shell() {
  const { user, family, loading, isParent, signOut } = useAuth();
  const [choosingLook, setChoosingLook] = useState(false);

  if (loading) {
    return (
      <div className="center-screen">
        <p className="muted">Loading…</p>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <div className="app">
      <header className="topbar">
        <span className="topbar__brand">💰 Allowance</span>
        <span className="topbar__spacer" />
        <span className="topbar__who">
          <strong>{user.displayName}</strong>
          <br />
          <span className="faint">{family?.name}</span>
        </span>
        <button
          type="button"
          className="btn btn--ghost topbar__look"
          onClick={() => setChoosingLook(true)}
          aria-label={isParent ? "Your colors" : "Change your look"}
          title={isParent ? "Your colors" : "Change your look"}
        >
          {isParent ? "🎨" : (user.avatar ?? FALLBACK_AVATAR)}
        </button>
        <button type="button" className="btn btn--ghost" onClick={signOut}>
          Sign out
        </button>
      </header>

      {isParent ? <ParentDashboard /> : <ChildDashboard />}

      {choosingLook ? (
        <AppearanceModal onClose={() => setChoosingLook(false)} />
      ) : null}
    </div>
  );
}
